import React, { Component } from "react";
import AuthLayout from "./../authLayout.js"
import SimpleReactValidator from 'simple-react-validator';
import service from '../../services'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'
import queryString from "query-string";
import Loader from "../../component/loader.js";
import ViewIcon from './../../icons/viewIcon';
import ShowPasswordIcon from './../../icons/ShowPassIcon';
import { Link } from "react-router-dom";

let setToken = '';
let sub;
const mapStateToProps = state => ({
    setToken : state.setToken
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
class Resigster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            confirmPassword: "",
            token:"",
            loaderFlag: false,
            passShow:false,
            confirmPassShow:false

        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();

    }

    componentDidMount = () => {
        let params = queryString.parse(this.props.location.search);
        let paramsData = this.props.location.search
        if(paramsData){
            paramsData = paramsData.split('=')
            
            if(paramsData && paramsData[1]){
                this.setState({referralCode:paramsData[1]})
                this.apiserve.sendevent("privateScreeningPartner|cms|getEmail", {referralCode: paramsData[1]});
            }
        }
       
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "privateScreeningPartner|cms|getEmail":
                    if(!response.error){
                        this.setState({ loaderFlag: false, email: response.data.email })
                    }else
                    {
                        this.apiserve.error('Something is wrong. please connect to admin')
                    } 
                break;
                case "privateScreeningPartner|getById":
                    if(!response.error){
                        this.props.ProfileName(response.data);
                        this.props.history.push('/partners-film-view')
                    }
                break;
                case "privateScreeningPartner|cms|register":
                    if(!response.data.token){
                        this.setState({ loaderFlag: false })
                    }  
                    break;      
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
      }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        },()=>{
            this.validate()
        });
    }

    registerUser = () => {
        this.apiserve.sendevent("privateScreeningPartner|cms|register", { 
            referralCode: this.state.referralCode,
            password:this.state.password,
        });
    }

    validate = () => {
        let emailErr = ''
        let passwordErr = '';
        let passwordMustSameError = ''
        if (!this.state.password) {
            passwordErr = 'Password can not be blank'
        }
        else {
            if (!this.state.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
                passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
            }
        }
        if (!this.state.confirmPassword) {
            passwordMustSameError = 'Confirm Password can not be blank'
        }else{
            if(this.state.password !== this.state.confirmPassword){
                passwordMustSameError = 'Password and Confirm Password do not match'
              }
        }
        
    
    
        if (!this.state.email) {
            emailErr = 'This field is required.'
          }else{
            if (!this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
              emailErr = 'Email address must be valid email.';
          }
        
        } 
        
    
        this.setState({
            passwordErr, emailErr,passwordMustSameError
        })
        if (passwordErr || emailErr || passwordMustSameError) {
            return false
        }
        return true
    }
    

    submitFn = (e) => {
        e.preventDefault();
        const isValid = this.validate()
        if (isValid) {
            this.setState({
                loaderFlag: true,
              });
              this.registerUser()
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    Showpassword = () => {
        this.setState({
            passShow: !this.state.passShow
        })
    }
    ConfirmShowpassword = () => {
        this.setState({
            confirmPassShow: !this.state.confirmPassShow
        })
    }

    clearFn = () => {
        this.setState({
            password: "",
            confirmPassword: "",
        });
    };

    render() {
        return (
            <AuthLayout>
                {/* Box Design Start here */}
                <div className="box_wrapper signUp_box_Wrapper forgot_box_Wrapper">
                    <h2 className="mb_0">Sign Up</h2>
                    <div>
                       Corporate partners may sign up to access the content management system
                    </div>
                    <form onSubmit={() => this.submitFn()}>
                        <div>
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                disabled
                                maxLength={255}
                                value={this.state.email}
                                onChange={this.onInputChange}
                            />
                            <span style={{ color: 'red' }}>{this.state.emailErr}</span>

                        </div>
                        <div>
                            <label>Password</label>
                            <div className="relative mb_0">
                                <input
                                    type={this.state.passShow ? "text" : "password"}
                                    name="password"
                                    id="password"
                                    value={this.state.password}
                                    onChange={this.onInputChange}
                                />
                                <span className="eye_icon" onClick={this.Showpassword}> { this.state.passShow ? <ShowPasswordIcon />  : <ViewIcon /> } </span>
                            </div>
                            <span style={{ color: 'red' }} className='srv-validation-message'>{this.state.passwordErr}</span>
                            {this.state.passwordErr ? '' :
                                <p className="suggession_text">Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.</p>
                            }
                        </div>
                        <div>
                            <label>Confirm Password</label>
                            <div className="relative mb_0">
                                <input
                                    type={this.state.confirmPassShow ? "text" :"password"}
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    value={this.state.confirmPassword}
                                    onChange={this.onInputChange}
                                />
                                <span className="eye_icon" onClick={this.ConfirmShowpassword}> { this.state.confirmPassShow ? <ShowPasswordIcon />  : <ViewIcon /> } </span>
                            </div>
                                {/* <span style={{ color: 'red' }}>{this.validator.message('confirm_password', this.state.confirmPassword, `required|in:${this.state.password}`, {messages: {in: 'Password and Confirm Password does not match.'}})}</span> */}
                                <span style={{ color: 'red' }} className='srv-validation-message'>{this.state.passwordMustSameError}</span>
                        </div>
                        <div>
                            <p className=" text_center">Go back to <Link className="link" to="/ps-signin">Sign in</Link> </p>
                        </div>
                        <div>
                            <button
                                className="grayBTN"
                                type="button"
                                onClick={() => this.clearFn()}
                            >Clear</button>
                            <button
                                className="orangeBTN"
                                type="submit"
                                onClick={(e) => this.submitFn(e)}
                            >Submit</button>

                        </div>
                    </form>
                </div>
                {/* Box Design End's here */}

                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader/>
                    ) : (
                    ""
                )}

            </AuthLayout>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Resigster)